<template>
    <button
        type="button"
        class="h-auto flex items-center font-gotham font-bold capitalize text-sm"
    >
        <img
            :src="imageUrl"
            :alt="iconName"
            class="mr-5"
        >

        <slot />
    </button>
</template>

<script>
    export default {
        props: {
            iconName: {
                type: String,
                required: true,
            },
        },

        computed: {
            imageUrl() {
                let iconUrl = '';

                if (this.iconName === 'check-green') {
                    iconUrl = new URL('../assets/images/icons/check-green.svg', import.meta.url);
                } else if (this.iconName === 'link') {
                    iconUrl = new URL('../assets/images/icons/link.svg', import.meta.url);
                } else if (this.iconName === 'email') {
                    iconUrl = new URL('../assets/images/icons/email.svg', import.meta.url);
                } else if (this.iconName === 'print') {
                    iconUrl = new URL('../assets/images/icons/print.svg', import.meta.url);
                } else if (this.iconName === 'heart') {
                    iconUrl = new URL('../assets/images/icons/heart.svg', import.meta.url);
                }

                return iconUrl;
            },
        },
    };
</script>
